import { Box, Dialog, DialogTitle, IconButton, Typography, useMediaQuery, useTheme } from "@mui/material";
import ReactPlayer from "react-player";
import ClosedCaptionIcon from "@mui/icons-material/ClosedCaption";
import { useState, useRef, useEffect } from "react";
import { CCTransition } from "./contentTypeData";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from 'react-i18next';

const CustomVideoPlayer = (props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { url, text, height } = props;
  const [ccModal, setCCModal] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const playerRef = useRef(null);

  const handleVisibilityChange = () => {
    if (playerRef.current) {
      if (document.hidden) {
        playerRef.current.getInternalPlayer().pause();
      }
    }
  };

  const handleIntersection = (entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting && playerRef.current) {
        playerRef.current.getInternalPlayer().pause();
      }
    });
  };

  useEffect(() => {
    document.addEventListener("visibilitychange", handleVisibilityChange);
    const observer = new IntersectionObserver(handleIntersection, { threshold: 0.1 });
    if (playerRef.current) {
      observer.observe(playerRef.current.wrapper);
    }
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      if (playerRef.current) {
        observer.unobserve(playerRef.current.wrapper);
      }
    };
  }, []);

  return (
    <>
      <Dialog
        open={ccModal}
        TransitionComponent={CCTransition}
        keepMounted
        onClose={() => setCCModal(false)}
        aria-describedby="alert-dialog-slide-description"
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "1rem",
          },
        }}
      >
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
          {t('transcript')}
          <IconButton onClick={() => setCCModal(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Typography sx={audioText}>{text}</Typography>
      </Dialog>
      <Box
        sx={audioPlayerStyle}
        onMouseEnter={() => setShowButton(true)}
        onMouseLeave={() => setShowButton(false)}
      >
        <ReactPlayer
          ref={playerRef}
          url={url}
          playing={false}
          loop={false}
          controls={true}
          width="100%"
          height="400px"
          style={{
            width: "100%",
            objectFit: "cover",
            maxHeight: "60vh"
          }}
        />
        {showButton && (
          <IconButton sx={ccVideoButton} onClick={() => setCCModal(true)}>
            <ClosedCaptionIcon />
          </IconButton>
        )}
      </Box>
    </>
  );
};

const audioPlayerStyle = {
  position: "relative",
  width: "100%",
  p: 0,
  borderRadius: "1.5rem",
  overflow: "hidden"
};

const ccVideoButton = {
  boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.2)",
  position: "absolute",
  top: "5px",
  right: "5px",
  color: (theme) => `${theme.palette.common.white}`,
  backgroundColor: (theme) => `${theme.palette.common.lightGray}`,
};

const audioText = {
  textAlign: "left",
  padding: "20px",
  margin: 0,
  overflow: "auto",
  whiteSpace:'pre-wrap'
};

export default CustomVideoPlayer;
